import * as React from "react";
import { forwardRef } from "react";
const SvgRelationNone = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 29 9",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10.5 5.50002H0V3.5H10.5V5.50002Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M29 5.5H18.5V3.49997H29V5.5Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	clipRule: "evenodd",
	d: "M14.5 9C16.9852 9 19 6.98528 19 4.5C19 2.01472 16.9852 0 14.5 0C12.0148 0 10 2.01472 10 4.5C10 6.98528 12.0148 9 14.5 9ZM14.5 7.5C16.1569 7.5 17.5 6.15685 17.5 4.5C17.5 2.84315 16.1569 1.5 14.5 1.5C12.8431 1.5 11.5 2.84315 11.5 4.5C11.5 6.15685 12.8431 7.5 14.5 7.5Z",
	fill: "currentColor",
	fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 4.5C16 5.32842 15.3284 6 14.5 6C13.6716 6 13 5.32842 13 4.5C13 3.67157 13.6716 3 14.5 3C15.3284 3 16 3.67157 16 4.5Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgRelationNone);
export default ForwardRef;
